export default class FloatingButton {
    constructor(node) {
        this.node = node
        this.contentClose = this.node.querySelector('.content-close')
        this.contentOpen = this.node.querySelector('.content-open')

        // Scroll offset in pixels after which the button should appear
        this.scrollOffset = 100
        // Estimated footer offset in pixels from which the button should disappear
        this.footerHeightOffset = 300
        this.desktopMediaQuery = '(min-width: 768px)'
        this.mobileUrl = 'https://api.whatsapp.com/send/?phone=390236616038&text=Ciao%2C+clicca+INVIO+per+iniziare+a+chattare+con+il+consulente+virtuale+di+Cofidis&app_absent=0'

        // Bind 'this' context for the scrollButtonBehaviour method
        this.scrollButtonBehaviour = this.scrollButtonBehaviour.bind(this)
        this.handleActivate = this.handleActivate.bind(this)
        this.handleKeydown = this.handleKeydown.bind(this)
        this.handleResize = this.handleResize.bind(this)

        this.init()
    }

    init() {
        // console.debug(' -> Floating button init')
        this.addListeners()
    }

    addListeners() {
        window.addEventListener('scroll', this.scrollButtonBehaviour)
        window.addEventListener('resize', this.handleResize)
        this.node.addEventListener('click', this.handleActivate)
        this.node.addEventListener('keydown', this.handleKeydown)
        // Execute the scroll behavior immediately to set the initial visibility state
        this.scrollButtonBehaviour()
        this.applyContentDisplayState(false)
        this.updateAccessibilityState()
    }

    isDesktop() {
        return window.matchMedia(this.desktopMediaQuery).matches
    }

    handleKeydown(event) {
        if( event.key === 'Enter' || event.key === ' ' ){
            event.preventDefault()
            this.handleActivate()
        }
    }

    handleActivate() {
        if( this.isDesktop() ){
            this.toggleDesktopPanel()
            return
        }

        window.open(this.mobileUrl, '_blank', 'noopener,noreferrer')
    }

    handleResize() {
        if( this.isDesktop() ){
            return
        }

        if( this.node.classList.contains('open') ){
            this.node.classList.remove('open')
            this.applyContentDisplayState(false)
            this.updateAccessibilityState()
        }
    }

    toggleDesktopPanel() {
        const isOpening = !this.node.classList.contains('open')

        if( isOpening ){
            this.applyContentDisplayState(true)
            requestAnimationFrame(() => {
                this.node.classList.add('open')
                this.updateAccessibilityState()
            })
            return
        }

        this.node.classList.remove('open')
        this.applyContentDisplayState(false)
        this.updateAccessibilityState()
    }

    applyContentDisplayState(isOpen) {
        if( this.contentClose ){
            this.contentClose.style.display = isOpen ? 'none' : 'flex'
        }

        if( this.contentOpen ){
            this.contentOpen.style.display = isOpen ? 'flex' : 'none'
        }
    }

    updateAccessibilityState() {
        const isOpen = this.node.classList.contains('open')

        this.node.setAttribute('aria-expanded', String(isOpen))
        this.node.setAttribute('aria-label', isOpen ? 'Chiudi assistente WhatsApp' : 'Apri assistente WhatsApp')

        if( this.contentClose ){
            this.contentClose.setAttribute('aria-hidden', String(isOpen))
        }

        if( this.contentOpen ){
            this.contentOpen.setAttribute('aria-hidden', String(!isOpen))
        }
    }

    scrollButtonBehaviour() {
        const currentScrollPos = window.scrollY
        const windowHeight = window.innerHeight
        const bodyHeight = document.body.offsetHeight

        // The scroll point from which the button should start to disappear
        // (total page height - window height - footer offset)
        const scrollBottomTrigger = bodyHeight - windowHeight - this.footerHeightOffset

        // Determine if the button should be visible
        const shouldBeVisible = currentScrollPos > this.scrollOffset && currentScrollPos < scrollBottomTrigger

        if( shouldBeVisible ){
            if( this.node.classList.contains('is-hidden') ){
                this.node.style.display = 'flex';

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.node.classList.remove('is-hidden')
                    })
                })
            }
        } else {
            if( !this.node.classList.contains('is-hidden') ){
                this.node.classList.add('is-hidden')
                this.node.addEventListener('transitionend', (event) => {
                    // Make sure the transition is on the element itself, not a child
                    if( event.target === this.node ){
                        this.hideNodeAfterTransition()
                    }
                }, { once: true })
            }
        }
    }

    // Callback to hide the node completely after the CSS transition
    hideNodeAfterTransition() {
        if( this.node.classList.contains('is-hidden') ){
            this.node.style.display = 'none'
        }
    }

    static reset() {
        // console.debug('  -> Floating button reset')
        FloatingButton.init()
    }

    static init() {
        // console.debug('== Floating button component ==');
        const buttonElement = document.querySelector('.floating-button')
        if( buttonElement ){
            FloatingButton.item = new FloatingButton(buttonElement)
        }
    }
}
